import { useCallback } from 'react';

import { ITournamentLeaderboardRepository } from 'domain/repositories/ITournamentLeaderboardRepository';
import { httpClient } from 'infrastructure/providers/common/httpClient';

import { TournamentRoutes } from './routes';

export const useTournamentLeaderboardRepository: ITournamentLeaderboardRepository = () => {
  const fetchTournamentLeaderboard: ReturnType<ITournamentLeaderboardRepository>['fetchTournamentLeaderboard'] =
    useCallback(
      (tournamentId: string) =>
        httpClient
          .get(TournamentRoutes.getTournamentLeaderboard(tournamentId))
          .then((response) => response.data),
      [],
    );

  return {
    fetchTournamentLeaderboard,
  };
};
